export function slugify(value: string) {
  return value
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .trim()
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

export function buildAutoSlug(title: string, nights: number, places: string[]) {
  if (!title.trim()) return '';
  const days = Math.max(1, nights + 1);
  const placesPart = (places || []).filter(Boolean).slice(0, 3).join('-');
  const durationPart = `${days}d-${nights}n`;
  const slugParts = [title, durationPart];
  if (placesPart) slugParts.push(placesPart);
  return slugify(slugParts.filter(Boolean).join(' '));
}
